import { render, staticRenderFns } from "./ConfirmPhone.vue?vue&type=template&id=08f0651d&scoped=true"
import script from "./ConfirmPhone.vue?vue&type=script&lang=js"
export * from "./ConfirmPhone.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPhone.vue?vue&type=style&index=0&id=08f0651d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f0651d",
  null
  
)

export default component.exports